// extracted by mini-css-extract-plugin
export default {"wrapper":"fifth_wrapper__VWIxW","title":"fifth_title__tEfch"};